var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/robot"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 2.333c-4.223 0-7.661 3.32-7.661 7.54v5.146c.386 3.479 3.711 6.967 7.647 6.967 3.935 0 7.26-3.488 7.647-6.967V9.873c0-4.22-3.41-7.54-7.633-7.54Zm0 0V.978m7.633 9.43h2.045v2m-2.045 2h2.045v-2m-17.34-2H2.304v2m2.036 2H2.303v-2m0 0H.908m20.77 0h1.444",
    className: "iconz"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.5 16.058h-7v2.39h7v-2.39ZM9 13c-2.651 0-2.651-5 0-5s2.651 5 0 5Zm6 0c-2.651 0-2.651-5 0-5s2.651 5 0 5Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.2f858a32da7f5fd5f4bc6c80451df4e0.svg";
export { ForwardRef as ReactComponent };